import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import { Table, Button } from '@enterprise-ui/canvas-ui-react';
import { isBefore } from 'date-fns';
import React, { useState, useEffect } from 'react';
import { checkDatePastRange, formatDate, checkDateInRange, ensureDate } from '../../utility.js';
import { isDateDisabled, checkSameDate, checkToday } from '../utils/gregorianUtility.js';

function RawCalendarDates(_ref) {
  var autoOk = _ref.autoOk,
    disableDates = _ref.disableDates,
    format = _ref.format,
    isGregorianRange = _ref.isGregorianRange,
    limitRange = _ref.limitRange,
    monthArr = _ref.monthArr,
    selectedDate = _ref.selectedDate,
    selectedRange = _ref.selectedRange,
    setDate = _ref.setDate,
    setIsCalendarVisible = _ref.setIsCalendarVisible;
  if (!isNaN(limitRange) && limitRange < 2) {
    limitRange = null;
    console.error('Hey Canvas User! The DatePicker expects the limitRange prop to be 2 or greater. Increase or use the non-range calendar instead.');
  }
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    hoverDate = _useState2[0],
    setHoverDate = _useState2[1];
  var _useState3 = useState({
      endDate: null,
      startDate: null
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    rangeDates = _useState4[0],
    setRangeDates = _useState4[1];
  useEffect(function () {
    var _rangeDates$startDate, _rangeDates$endDate;
    if (((_rangeDates$startDate = rangeDates.startDate) === null || _rangeDates$startDate === void 0 ? void 0 : _rangeDates$startDate.length) > 0 && ((_rangeDates$endDate = rangeDates.endDate) === null || _rangeDates$endDate === void 0 ? void 0 : _rangeDates$endDate.length) > 0) {
      setDate(rangeDates, true);
      autoOk && setIsCalendarVisible(false);
    }
    //eslint-disable-next-line
  }, [rangeDates]);
  var setRangeFunction = function setRangeFunction(date) {
    var startDate = rangeDates.startDate || '';
    var endDate = rangeDates.endDate || '';
    if (typeof rangeDates.startDate !== 'string') {
      startDate = date;
    } else if (isBefore(ensureDate(date), ensureDate(startDate))) {
      startDate = date;
    } else {
      endDate = date;
    }
    setRangeDates({
      endDate: endDate,
      startDate: startDate
    });
    setDate({
      endDate: endDate,
      startDate: startDate
    });
  };
  var handleResizeClick = function handleResizeClick(e) {
    var _rangeDates$startDate2, _rangeDates$endDate2;
    if (((_rangeDates$startDate2 = rangeDates.startDate) === null || _rangeDates$startDate2 === void 0 ? void 0 : _rangeDates$startDate2.length) > 0 && ((_rangeDates$endDate2 = rangeDates.endDate) === null || _rangeDates$endDate2 === void 0 ? void 0 : _rangeDates$endDate2.length) <= 0) {
      var _e$target;
      setHoverDate(e === null || e === void 0 ? void 0 : (_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.ariaLabel);
    }
  };
  return /*#__PURE__*/React.createElement(Table, {
    name: "date picker",
    className: "C-DatePicker__Table"
  }, /*#__PURE__*/React.createElement(Table.Head, null, /*#__PURE__*/React.createElement(Table.Row, {
    key: "weekdays",
    justify: "flex-end"
  }, /*#__PURE__*/React.createElement(Table.Header, {
    key: "weekday_su",
    className: "C-DatePicker__DataCell"
  }, "Su"), /*#__PURE__*/React.createElement(Table.Header, {
    key: "weekday_mo",
    className: "C-DatePicker__DataCell"
  }, "Mo"), /*#__PURE__*/React.createElement(Table.Header, {
    key: "weekday_tu",
    className: "C-DatePicker__DataCell"
  }, "Tu"), /*#__PURE__*/React.createElement(Table.Header, {
    key: "weekday_we",
    className: "C-DatePicker__DataCell"
  }, "We"), /*#__PURE__*/React.createElement(Table.Header, {
    key: "weekday_th",
    className: "C-DatePicker__DataCell"
  }, "Th"), /*#__PURE__*/React.createElement(Table.Header, {
    key: "weekday_fr",
    className: "C-DatePicker__DataCell"
  }, "Fr"), /*#__PURE__*/React.createElement(Table.Header, {
    key: "weekday_sa",
    className: "C-DatePicker__DataCell"
  }, "Sa"))), /*#__PURE__*/React.createElement(Table.Body, null, monthArr.map(function (week, weekIndex) {
    return /*#__PURE__*/React.createElement(Table.Row, {
      justify: weekIndex === 0 ? 'flex-end' : 'flex-start',
      key: "week_".concat(weekIndex)
    }, week.map(function (day, dayIndex) {
      var isDateVisible = day.dateNumber !== undefined;
      var isPastRange = limitRange && rangeDates.startDate && checkDatePastRange(rangeDates.startDate, day.value, limitRange);
      var isDisabled = isDateVisible && (isDateDisabled(day, disableDates) || isPastRange);
      var isSelected = !isDisabled && isGregorianRange ? checkSameDate(day.value, selectedRange === null || selectedRange === void 0 ? void 0 : selectedRange.startDate) || checkSameDate(day.value, selectedRange === null || selectedRange === void 0 ? void 0 : selectedRange.endDate) : checkSameDate(day.value, selectedDate);
      var isDateToday = checkToday(day.value);
      var formattedDate = formatDate(day.value, format);
      var isInRange = checkDateInRange(selectedRange === null || selectedRange === void 0 ? void 0 : selectedRange.startDate, hoverDate ? hoverDate : selectedRange === null || selectedRange === void 0 ? void 0 : selectedRange.endDate, day.value);
      return /*#__PURE__*/React.createElement(Table.Data, {
        className: "date_".concat(weekIndex, "_").concat(dayIndex, " C-DatePicker__DataCell"),
        key: "date_".concat(weekIndex, "_").concat(dayIndex)
      }, /*#__PURE__*/React.createElement(Button, {
        iconOnly: true,
        disabled: isDisabled,
        "aria-label": formattedDate || 'loading',
        className: "\n                      C-DatePicker__DateButton --embeddedInComponent ".concat(day && isSelected ? 'isSelected' : '', " ").concat(isDateVisible ? '' : 'isHidden', " ").concat(isDisabled ? 'isDisabled' : '', " ").concat(isDateToday ? 'isToday' : '', " ").concat(isInRange ? 'isRange' : '', "\n                    "),
        onMouseOver: handleResizeClick,
        onClick: function onClick() {
          if (isGregorianRange) {
            setRangeFunction(formattedDate);
          } else {
            setDate(formattedDate, true);
            autoOk && setIsCalendarVisible(false);
          }
        }
      }, day.dateNumber));
    }));
  })));
}
RawCalendarDates.displayName = 'CalendarDates';
var CalendarDates = RawCalendarDates;

export { CalendarDates as default };
